<template>
  <div class="container-fluid d-flex flex-column flex-grow-1 mt-3">
    <div class="animated fadeIn">
      <b-row>
        <b-col lg="12">
          <transition name="fade">
            <b-card no-body>
              <div slot="header">
                <i class="fa fa-edit"></i> {{ pageName }}
                <div class="card-header-actions">
                  <b-link class="card-header-action btn-minimize" v-b-toggle.collapse1>
                    <i class="icon-arrow-up"></i>
                  </b-link>
                </div>
              </div>
              <b-collapse id="collapse1" visible>
                <b-card-body>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Message</label>
                        <div>{{ item.message }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Created Date</label>
                        <div>{{ dateFormat(item.createdDate) }}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Active Count</label>
                        <div>{{ item.activeCount }}</div>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <label class="text-black-50">Inactive Count</label>
                        <div>{{ item.inactiveCount }}</div>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6" class="py-3">
                      <img v-if="item.image && item.image.imageUrl" style="width: 300px; height: auto;" :src="baseUrl + item.image.imageUrl" alt="img">
                    </b-col>
                  </b-row>
                  <div class="d-flex justify-content-end">
                    <div class="form-actions">
                      <router-link type="cancel" class="btn btn-secondary" variant="secondary" :to="'/broadcast'">Cancel</router-link>
                    </div>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </transition>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { API_SERVER } from '../../constants/constants'
export default {
  name: 'BroadcastSummaryPage',
  data () {
    return {
      item: {}
    }
  },
  created () {
    if (!this.$route.params.id || this.$route.params.id <= 0) {
      return
    }
    this.$loading.show()
    this.axios.get('broadcast/item', {params: {id: this.$route.params.id}})
      .then(response => {
        if (response.data) {
          this.item = response.data.data
        }
        this.$loading.hide()
      })
      .catch(error => {
        this.$loading.hide()
        if (error.response && error.response.data.status === 400) {
          this.$toastr.error(error.response.data.message)
        }
      })
  },
  methods: {
    dateFormat (date) {
      return date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  computed: {
    pageName () {
      return 'Broadcast Summary'
    },
    baseUrl () {
      return API_SERVER
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/broadcast/BroadcastSummaryPage.vue